import { changePage } from 'feature/payments/paymentSlice';
import useDevice from 'hooks/DesktopDevice.hook';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Pagination, Stack } from 'styles';
import DownloadButton from '../PaymentDetails/PaymentDetailsSections/DownloadButton.component';

const PaymentClaimsFooter = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { isDesktop } = useDevice();
	const { pages = 10, page } = useSelector(
		(store: RootState) => store.payment.paymentRun,
	);

	const handleChangePage = (
		event: React.ChangeEvent<unknown>,
		value: number,
	) => {
		event.preventDefault();
		dispatch(changePage(value));
	};

	return (
		<Stack
			direction={'row'}
			position={'relative'}
			sx={{ my: !!isDesktop ? 4.25 : 3 }}
			alignItems={'center'}
			justifyContent={'center'}
		>
			<Stack
				minHeight="24px"
				direction={'row'}
				flexGrow={1}
				sx={{
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Stack></Stack>
				{pages > 1 ? (
					<Pagination page={page} count={pages} onChange={handleChangePage} />
				) : null}

				<DownloadButton type={'eop'} />
			</Stack>
		</Stack>
	);
};

export default PaymentClaimsFooter;
